import React, { Component } from "react";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getUserData } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (

            <div id="wrapper">
                <Sidebar act="home" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item active">Home</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">Home</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            Home
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: getUserData(state),
    }
}

export default compose(withRouter, connect(mapStateToProps))(Home);